module.exports = __webpack_public_path__ + "img/thief_golden.1a67d9cb.svg";